import { render, staticRenderFns } from "./MapColumns.vue?vue&type=template&id=8723181a&scoped=true"
import script from "./MapColumns.vue?vue&type=script&lang=js"
export * from "./MapColumns.vue?vue&type=script&lang=js"
import style0 from "./MapColumns.vue?vue&type=style&index=0&id=8723181a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8723181a",
  null
  
)

export default component.exports